import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=54ac27bb"
import script from "./Delete.vue?vue&type=script&lang=ts"
export * from "./Delete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports